/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React from 'react'
import { Footer } from 'flowbite-react';
import { BsDribbble, BsFacebook, BsGithub, BsInstagram, BsTwitter,BsLinkedin,BsYoutube,BsSkype,BsPinterest,BsTelegram } from 'react-icons/bs';

function Footersection() {
  return (
   <>
 
    <Footer className='bg-gray-300 bg-opacity-40' >
      <div className="w-full">
        <div className="grid w-full grid-cols-2 gap-8 px-6 py-8 md:grid-cols-4">
          <div>
            <Footer.Title title="Company" />
            <Footer.LinkGroup col>
              <Footer.Link href="/About">About</Footer.Link>
              <Footer.Link href="/Jobs">Careers</Footer.Link>
              <Footer.Link href="/Contact">Contact Us </Footer.Link>
              <Footer.Link href="/Blog">Blog</Footer.Link>
            </Footer.LinkGroup>
          </div>
          <div>
            <Footer.Title title="help center" />
            <Footer.LinkGroup col>
              <Footer.Link href="mailto:dailyle.company@gmial.com">Support </Footer.Link> 
              <Footer.Link href="/Contact">Contact Us</Footer.Link>
              <Footer.Link href="mailto:contact@dailyle.com" > Mail </Footer.Link>
            </Footer.LinkGroup>
          </div>
          <div>
            <Footer.Title title="legal" />
            <Footer.LinkGroup col>
              <Footer.Link href="/Privacy">Privacy Policy</Footer.Link> 
              <Footer.Link href="/Terms">Terms &amp; Conditions</Footer.Link>
            </Footer.LinkGroup>
          </div>
          <div>
            <Footer.Title title="download" />
            <Footer.LinkGroup col>
              <Footer.Link href="/">iOS</Footer.Link>
              <Footer.Link href="https://play.google.com/store/apps/details?id=com.dailyleappofficial.com.dailyle">Android</Footer.Link>  
            </Footer.LinkGroup>
          </div>
        </div>
        <div className="w-full bg-purple-600 bg-opacity-100 px-4 py-6 sm:flex sm:items-center sm:justify-between">
          <Footer.Copyright className='text-white' href="https://www.instafinancials.com/company/dailyle-tech-private-limited/U72200OR2022PTC041442"  target="_blank" by="Dailyle Tech Private Limited" year={2024} />
          <div className="mt-4 flex space-x-6 sm:mt-0 sm:justify-center">
            <Footer.Icon className='text-white' href="https://www.facebook.com/dailyleapp/" icon={BsFacebook} />
            <Footer.Icon className='text-white' href="https://www.instagram.com/dailyle.official/" icon={BsInstagram} />
            <Footer.Icon className='text-white' href="https://twitter.com/dailyleofficial" icon={BsTwitter} />
            <Footer.Icon className='text-white' href="https://www.youtube.com/channel/UCmvHc-SYac_NVx5i1AvSFJw" icon={BsYoutube} />
            <Footer.Icon className='text-white' href="https://in.linkedin.com/company/dailyle" icon={BsLinkedin} />
            <Footer.Icon className='text-white' href="https://t.me/dailyleofficialapp" icon={BsTelegram} />
            <Footer.Icon className='text-white' href="https://in.pinterest.com/dailyleapp/" icon={BsPinterest} />
            <Footer.Icon className='text-white' href="https://join.skype.com/invite/lA4i7mmMzEhl" icon={BsSkype} />
          </div>
        </div>
      </div>
    </Footer>
  

   </>
  )
}

export default Footersection